import { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";

/**
 * Cross-fading image rotator. Pass an array of image URLs; it auto-rotates
 * every `interval` ms. Falls back gracefully to a single image or nothing.
 */
export function RotatingImage({ images = [], alt = "", className = "", interval = 5000, testid = "rotating-image" }) {
  const list = (images || []).filter(Boolean);
  // Start on a random image each visit so returning visitors see variety,
  // then continue rotating from there.
  const [idx, setIdx] = useState(() => (list.length > 0 ? Math.floor(Math.random() * list.length) : 0));

  useEffect(() => {
    if (list.length <= 1) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), interval);
    return () => clearInterval(t);
  }, [list.length, interval]);

  if (list.length === 0) return null;

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testid}>
      {list.map((url, i) => (
        <img
          key={`${url}-${i}`}
          src={fileUrl(url)}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ease-in-out"
          style={{ opacity: i === idx ? 1 : 0 }}
        />
      ))}
    </div>
  );
}
